import { CardHeaderCore } from "src/Pages/components/CardCore/Components/CardHeaderCore";
import { ReportParcelasAbertasPDF } from "./Components/PDF/ReportConfirmationContractPDF";
import { DrawerFilterParcelasAbertas } from "./Components/DrawerFilter/DrawerFilterParcelasAbertas";
import { PreviewIcon } from "src/Pages/components/Icons/Icons";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useContextReportsProduction } from "src/Contexts/ReportProduction/ReportsProductionContextContext";
import { NoEmptyPdfCore } from "src/Pages/components/PDF/NoEmpty/NoEmptyPdfCore";

export const PageReportParcelasAbertas = () => {
  const { loadingGravar } = useConfigPageContext();
  const { listReportConfirmationContract } = useContextReportsProduction();

  const hasData = !!listReportConfirmationContract?.data?.length;

  return (
    <>
      <CardHeaderCore
        buttonAdd={[<DrawerFilterParcelasAbertas key="filter" />]}
        icon={<PreviewIcon color="primary" sx={{ fontSize: "20px" }} />}
        sxStyle={{ margin: "1px 0 16px 0", padding: "12px" }}
        subTitle="Gere relatórios detalhados de parcelas abertas com filtros personalizados"
        title="Relatório de parcelas abertas"
      />

      <ReportParcelasAbertasPDF />

      {!hasData && !loadingGravar && (
        <NoEmptyPdfCore />
      )}
    </>
  );
};
